import { render, staticRenderFns } from "./Ruteador.vue?vue&type=template&id=53aacb63&"
import script from "./Ruteador.vue?vue&type=script&lang=js&"
export * from "./Ruteador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports